var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"topbanner"},[_c('h2',[_vm._v(_vm._s(_vm.page_title))])]),_vm._v(" "),_c('article',{staticClass:"main_contents"},[_c('div',{staticClass:"main_contents_insub",domProps:{"innerHTML":_vm._s(_vm.page_contents)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b2ae2f4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Contents.vue
// module id = null
// module chunks = 